import { SORT_ORDER } from '../constants/filter.constant';
import { DefaultResponse } from '../interfaces/index';
import api from '../api';
import { AxiosResponse } from 'axios';

const DEPARTMENT_URL = '/ris/departments/v1';

export interface ParamsGetDepartment {
  limit?: number;
  offset?: number;
  sort_field?: '' | 'name' | 'created_at' | 'updated_at';
  sort_order?: SORT_ORDER;
  institution_ids?: string[];
  active?: boolean;
}
export interface ResponseGetDepartment extends DefaultResponse {
  data: {
    code: string;
    created_at: string;
    id: string;
    name: string;
    result_delivery_location: string;
    active: boolean;
    updated_at: string;
  }[];
}
export const getDepartments = async (
  params: ParamsGetDepartment = {
    limit: 100,
    offset: 0,
  }
) => {
  const response = (await api({
    url: DEPARTMENT_URL,
    method: 'GET',
    params,
    timeout: 30_000,
  })) as AxiosResponse<ResponseGetDepartment>;

  return response.data;
};

export interface ParamsCreateDepartment {
  code: string;
  name: string;
}
export const createDepartment = async (data: ParamsCreateDepartment) => {
  const response = (await api({
    url: DEPARTMENT_URL,
    method: 'POST',
    data,
  })) as AxiosResponse<ResponseGetDepartment>;

  return response.data;
};

export const updateDepartment = async (id: string, data: ParamsCreateDepartment) => {
  const response = (await api({
    url: `${DEPARTMENT_URL}/${id}`,
    method: 'PUT',
    data,
  })) as AxiosResponse<ResponseGetDepartment>;

  return response.data;
};

export const deleteDepartment = async (id: string) => {
  return (await api({
    url: `${DEPARTMENT_URL}/${id}`,
    method: 'DELETE',
  })) as AxiosResponse<any>;
};
